import * as actions from '../../actions/admin';

export const initialState = {
    loading: false,
    showSuccess: false,
    errorMessage: '',
    errorType: '',
    businessUnits: [],
    collections: [],
    collectionWithLicenseInformation: [],
    competencies: [],
    competencyAreas: [],
    departments: [],
    integrationFields: [],
    locations: [],
    profiles: [],
    profileGroups: [],
    roles: [],
    crmJobs: [],
    settings: { loading: true },
    tags: [],
};

export const adminState = (state = initialState, action) => {
    switch (action.type) {
        case actions.ADMIN_LOADING:
            return { ...state, loading: action.payload };
        case actions.ADMIN_LOADING_ERROR:
            return { ...state, ...action.payload };
        case actions.ADMIN_CLEAR_ERROR:
            return { ...state, errorMessage: '', errorType: null };
        case actions.ADMIN_LOAD_SUCCESS:
            switch (action.payload.route) {
                case 'business-unit':
                    return { ...state, businessUnits: action.payload.data };
                case 'collections':
                    return { ...state, collections: action.payload.data };
                case 'collections-with-license-information':
                    return { ...state, collectionWithLicenseInformation: action.payload.data };
                case 'competency':
                    return { ...state, competencies: action.payload.data };
                case 'competency-area':
                    return { ...state, competencyAreas: action.payload.data };
                case 'department':
                    return { ...state, departments: action.payload.data };
                case 'integration-fields':
                    return { ...state, integrationFields: action.payload.data };
                case 'location':
                    return { ...state, locations: action.payload.data };
                case 'profile':
                    return { ...state, profiles: action.payload.data };
                case 'profilegroups':
                    return { ...state, profileGroups: action.payload.data };
                case 'role':
                    return { ...state, roles: action.payload.data };
                case 'crm-job':
                    return { ...state, crmJobs: action.payload.data };
                case 'setting':
                    return { ...state, settings: action.payload.data };
                case 'tag':
                    return { ...state, tags: action.payload.data };
                default:
                    return { ...state };
            }
        default:
            return state;
    }
};
